import { formatDate } from '$components'
import { Text } from '$components'

export type DateCellProps = {
  date?: string | null
}

export function DateCell({ date }: DateCellProps) {

  return (
    <Text className="text-sm text-nowrap">
      { date ? formatDate(date) : '-' }
    </Text>
  )
}
